import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IScanQROrderFeature } from './scan-qr-order.feature.state';
import { ScanQROrderState } from './scan-qr-order.state';

export const getScanQROrderState: MemoizedSelector<IScanQROrderFeature, ScanQROrderState> = createFeatureSelector<ScanQROrderState>(
  nameof<IScanQROrderFeature>('ScanQROrderFeature')
);

export const getIsLoading = createSelector(getScanQROrderState, (state: ScanQROrderState) => state.isLoading);

export const getFailures = createSelector(getScanQROrderState, (state: ScanQROrderState) => state.failures);

export const getOrderFromSite = createSelector(getScanQROrderState, (state: ScanQROrderState) => state.orderFromSite);

export const getSiteId = createSelector(getScanQROrderState, (state: ScanQROrderState) => state.siteId);

// export const getScanQROrder = createSelector(getScanQROrderState, (state: ScanQROrderState) => state.ScanQROrder);
